import type { PsfShareChannel, ShareChannel } from 'src/app/pages/psf/share/shared/types';

export const SHARE_CHANNELS: Partial<Record<string, true>> = {
	copy: true,
	email: true,
	facebook: true,
	facebookMessenger: true,
	instagram: true,
	line: true,
	sms: true,
	twitter: true,
	vk: true,
	whatsapp: true,
	nextdoor: true,
	mobileNativeShare: true,
	reddit: true,
} satisfies Record<ShareChannel, true>;

export const PSF_SHARE_CHANNELS: Record<PsfShareChannel, true> = {
	copy: true,
	email: true,
	facebook: true,
	facebookMessenger: true,
	instagram: true,
	instagramStories: true,
	line: true,
	mobileNativeShare: true,
	nextdoor: true,
	reddit: true,
	sms: true,
	tiktok: true,
	twitter: true,
	vk: true,
	whatsapp: true,
};
